import Marquee from "react-fast-marquee";

const ITEMS = [
  "Accurate Patent Data",
  "Verified Deadlines",
  "Greater IP Confidence",
  "Structured Validation Workflows",
  "Portfolio Data Quality",
  "Patent Records Verification",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="bg-navy-deep border-y border-white/10 py-6 overflow-hidden">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-display font-light text-slate-400 text-lg tracking-wide mx-10 whitespace-nowrap">
              {item}
            </span>
            <span className="text-blue-500 text-xs">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
